import React from 'react';
import { Skeleton } from 'antd';
import { I18n } from '@aws-amplify/core';
import { RiskBadge } from '../RiskBadge';
import { Risk } from '@/components/views/Resolution886/enums';
import * as S from './styles';

interface Category {
	id: string;
	name: any;
	risk: Risk | undefined;
	status: boolean | undefined;
}

interface CategoryButtonProps {
	loading?: boolean;
	name?: string;
	category: Category;
	onClick: (id: string) => void;
}

export default function CategoryButton({
	loading = false,
	name = '',
	category,
	onClick
}: Readonly<CategoryButtonProps>): JSX.Element {
	return (
		<S.Container span={24} lg={12}>
			{loading ? (
				<Skeleton.Button active />
			) : (
				<S.CategoryButton onClick={() => onClick(category.id)}>
					<p>{I18n.get(name || category.name)}</p>
					{category.status ? <RiskBadge risk={category.risk} /> : <RiskBadge text="Evaluation not started" />}
				</S.CategoryButton>
			)}
		</S.Container>
	);
}
